// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./yote.scss
// module id = 1496
// module chunks = 1